import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Divider,
  Image,
} from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function ItemContainer({
  topic,
  itemid,
  text,
  img,
  isSmall,
  gallery,
  isProduct,
  product,
  blogPost,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBlogPage = (blogId) => {
    const lng = localStorage.getItem("lng");
    const newPath = `/${lng}/blog-detail/${blogId}`;
    navigate(newPath);
  };

  return (
    <>
      {isSmall ? (
        <Card
          className="mb-1 mt-3 relative z-50 rounded-md border hover:scale-95 "
          onClick={() =>
            navigate(
              `/${localStorage.getItem("lng")}/products/?category=${itemid}`
            )
          }
        >
          <CardBody className="!px-0 !py-0  ">
            <Image
              src={img || "/Assets/Images//Assets/Images/images.png"}
              alt={topic}
              className="rounded-none object-cover h-[15rem]  lg:h-[300px]"
              width="100%"
              onClick={() =>
                navigate(
                  `/${localStorage.getItem("lng")}/products/?category=${itemid}`
                )
              }
            />
          </CardBody>
          <CardFooter className="!py-0 !px-0 !rounded-none">
            <Button
              className="w-full bg-white text-black hover:bg-primary hover:text-white rounded-none  text-lg "
              onClick={(e) => {
                e.stopPropagation();
                navigate(
                  `/${localStorage.getItem("lng")}/products/?category=${itemid}`
                );
              }}
            >
              {topic}
            </Button>
          </CardFooter>
        </Card>
      ) : (
        <div
          className="flex  gap-4 !p-0 cursor-pointer mb-12 "
          onClick={() => handleBlogPage(blogPost.id)}
        >
          <Card className=" w-full !rounded-tr-md !rounded-tl-md rounded-none ">
            <div className="!px-0">
              <Image
                src={img || "/Assets/Images/images.png"}
                alt={topic}
                className="rounded-none object-cover border-none  "
                width="100%"
                height="250px"
              />

              <h1 className="text-center text-[17px]  text-blue-950  xl:text-[16px] font-extrabold m-3">
                {topic}
                <Divider className="mt-2 mb-2  " />
              </h1>

              <div className="text-gray-600">
                {!isProduct && text && (
                  <p className="leading-loose text-[15px] px-4  text-right">
                    {text}
                  </p>
                )}
              </div>
            </div>

            <Button
              variant="bordered"
              className="w-full bg-primary text-white hover:bg-white hover:text-black  rounded-none border-none  mt-5 "
              onClick={() => handleBlogPage(blogPost.id)}
            >
              {t("Read")}
            </Button>
          </Card>
        </div>
      )}
    </>
  );
}
